module.exports = __webpack_public_path__ + "img/gelocatil.07668437.jpeg";